<template>
  <div class="common-page contour">
    <!-- 背景装饰元素 -->
    <div class="bg-decoration">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
      <div class="circle circle-3"></div>
      <div class="circle circle-4"></div>
      <div class="wave wave-1"></div>
      <div class="wave wave-2"></div>
    </div>
    <div class="common-box">
      <slot></slot>
    </div>
    <div class="common-footer">
      <p>版权所有 ©2026-2027 深圳维盟科技股份有限公司成都分公司.ALL RIGHTS RESERVED.</p>
      <p><a href="https://beian.miit.gov.cn" target="_blank">蜀ICP备17005920号-2</a></p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CommonPage",
  }
</script>

<style scoped lang="scss">
  .common-page {
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #1e40af 0%, #2563eb 50%, #3b82f6 100%);
    background-size: 400% 400%;
    animation: gradientBG 15s ease infinite;
    position: relative;
    text-align: center;
    overflow-y: auto;
    overflow-x: hidden;
    
    .bg-decoration {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      pointer-events: none;
      z-index: 1;
      
      .circle {
        position: absolute;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.1);
        animation: float 20s infinite ease-in-out;
      }
      
      .circle-1 {
        width: 300px;
        height: 300px;
        top: -100px;
        left: -100px;
        animation-delay: 0s;
      }
      
      .circle-2 {
        width: 200px;
        height: 200px;
        top: 20%;
        right: -50px;
        animation-delay: -5s;
      }
      
      .circle-3 {
        width: 150px;
        height: 150px;
        bottom: 30%;
        left: 10%;
        animation-delay: -10s;
      }
      
      .circle-4 {
        width: 250px;
        height: 250px;
        bottom: -100px;
        right: 10%;
        animation-delay: -15s;
      }
      
      .wave {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 200%;
        height: 200px;
        background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 320'%3E%3Cpath fill='rgba(255,255,255,0.1)' d='M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z'%3E%3C/path%3E%3C/svg%3E") repeat-x;
        background-size: 50% 100%;
        animation: wave 15s linear infinite;
      }
      
      .wave-2 {
        bottom: 10px;
        opacity: 0.5;
        animation: wave 20s linear infinite reverse;
      }
    }

    .common-box {
      display: inline-block;
      vertical-align: middle;
      max-width: 440px;
      width: 90%;
      position: relative;
      z-index: 100;
      box-sizing: border-box;
      padding: 50px 45px;
      border-radius: 20px;
      background-color: rgba(255, 255, 255, 0.98);
      backdrop-filter: blur(20px);
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
      animation: slideUp 0.8s ease-out;
      
      /deep/ {
        .el-input--prefix {
          .el-input__inner {
            padding-left: 40px;
            height: 48px;
            border-radius: 8px;
            border: 2px solid #e8e8e8;
            transition: all 0.3s ease;
            
            &:focus {
              border-color: $home-color;
              box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
              transform: scale(1.02);
            }
            
            &:hover {
              border-color: #93c5fd;
            }
          }
          .el-input__prefix {
            .el-input__icon {
              color: $home-color;
              font-size: 18px;
              transition: transform 0.3s ease;
            }
          }
          
          &:hover {
            .el-input__prefix {
              .el-input__icon {
                transform: scale(1.2);
              }
            }
          }
          
          &.is-focus {
            .el-input__prefix {
              .el-input__icon {
                animation: iconBounce 0.5s ease;
              }
            }
          }
        }
      }
      .common-logo {
        width: 100px;
        height: 100px;
        border: 5px solid $home-color;
        border-radius: 100px;
        background: #fff;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        color: $home-color;
        i {
          vertical-align: middle;
          font-size: 50px;
        }
      }
    }
    @media screen and (max-width:550px){
      .common-box{
        padding: 35px 25px;
        /deep/ {
          .el-form {
            text-align: left;
            .el-form-item__label {
              float: none;
            }
            .el-form-item__content {
              margin: 0!important;
            }
          }
        }
      }
      .common-footer {
        display: none;
      }
    }
    .common-footer {
      text-align: center;
      position: absolute;
      color: rgba(255, 255, 255, 0.8);
      bottom: 30px;
      left: 0;
      right: 0;
      font-size: 13px;
      line-height: 1.8;
      z-index: 99;
      a {
        text-decoration: none;
        color: rgba(255, 255, 255, 0.9);
        transition: color 0.3s ease;
        &:hover {
          color: #fff;
        }
      }
    }
  }
  
  @keyframes gradientBG {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
  
  @keyframes float {
    0%, 100% {
      transform: translateY(0) rotate(0deg);
    }
    25% {
      transform: translateY(-30px) rotate(5deg);
    }
    50% {
      transform: translateY(-20px) rotate(0deg);
    }
    75% {
      transform: translateY(-40px) rotate(-5deg);
    }
  }
  
  @keyframes wave {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }
  
  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(40px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes iconBounce {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.3);
    }
  }
</style>
